import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

type Context = {
  isFreezed: boolean;
  registerFreezeId: (id: string) => void;
  unregisterFreezeId: (id: string) => void;
};

const CalendarFreezeContext = createContext<Context>({
  isFreezed: false,
  registerFreezeId: () => null,
  unregisterFreezeId: () => null,
});

export const CalendarFreezeContextProvider = ({ children }) => {
  const [freezeIds, setFreezeIds] = useState<string[]>([]);

  const registerFreezeId = useCallback(
    (id: string) => setFreezeIds((s) => (s.includes(id) ? s : [...s, id])),
    [setFreezeIds],
  );

  const unregisterFreezeId = useCallback(
    (id: string) => setFreezeIds((s) => s.filter((el) => el !== id)),
    [setFreezeIds],
  );

  const isFreezed = useMemo(() => freezeIds.length > 0, [freezeIds]);

  return (
    <CalendarFreezeContext.Provider
      value={{
        isFreezed,
        registerFreezeId,
        unregisterFreezeId,
      }}
    >
      {children}
    </CalendarFreezeContext.Provider>
  );
};

export const useCalendarFreeze = () => useContext(CalendarFreezeContext);
